export const MAP_DATA = {
    tileServerUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    centerLocation: [-36.8520950, 174.7631803], // Auckland location
    copyright: '&#169; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
    zoomLevel: {
        min: 6,
        max: 19,
        initial: 14,
    },
    maxZoomLevelForDrawing: 13,
};
